@if (loading) {
<div class="ach-card ach-card--skeleton">
  <div class="ach-sk__header sk-bone"></div>
  <div class="ach-sk__bar sk-bone"></div>
  <div class="ach-sk__grid">
    @for (_ of [0,1,2,3]; track $index) {
      <div class="ach-sk__badge">
        <div class="ach-sk__hex sk-bone"></div>
        <div class="ach-sk__lbl sk-bone"></div>
      </div>
    }
  </div>
</div>
} @else if (config) {
<div class="ach-card">

  <!-- ── Header ──────────────────────────────────────────────────────── -->
  @if (config.title) {
  <div class="ach-card__header">
    @if (config.headerIcon) {
      <span class="ach-card__header-icon">
        <i class="pi {{ config.headerIcon }}"></i>
      </span>
    } @else {
      <span class="ach-card__dot"></span>
    }
    <h4 class="ach-card__title">{{ config.title }}</h4>
    <span class="ach-card__counter">
      {{ unlocked }}<span class="ach-card__counter-sep">/</span>{{ total }}
    </span>
  </div>
  }

  <!-- ── Barra de progreso global ─────────────────────────────────── -->
  <div class="ach-progress">
    <div class="ach-progress__track">
      <div class="ach-progress__fill"
           [style.width.%]="progressPct"
           [style.background]="progressColor()"
           [style.box-shadow]="'0 0 8px ' + progressColor() + '88'">
      </div>
    </div>
    <span class="ach-progress__label">{{ progressPct }}% logros desbloqueados</span>
  </div>

  <!-- ── Grid de badges ───────────────────────────────────────────── -->
  <div class="ach-grid">
    @for (badge of config.badges; track badge.id) {

      <div class="ach-badge"
           [class.ach-badge--unlocked]="badge.unlocked"
           [class.ach-badge--locked]="!badge.unlocked"
           (mouseenter)="showTooltip(badge.id)"
           (mouseleave)="hideTooltip()"
           (touchstart)="showTooltip(badge.id); $event.preventDefault()"
           (touchend)="hideTooltip()">

        <!-- SVG hexagonal frame -->
        <div class="ach-badge__frame">
          <svg class="ach-badge__svg" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient [id]="gradId(badge.id)" x1="0%" y1="0%" x2="100%" y2="100%">
                @if (badge.unlocked) {
                  <stop offset="0%"   [attr.stop-color]="badge.color" stop-opacity="1"/>
                  <stop offset="100%" [attr.stop-color]="badge.color" stop-opacity="0.4"/>
                } @else {
                  <stop offset="0%"   stop-color="#4a4a5a" stop-opacity="1"/>
                  <stop offset="100%" stop-color="#2a2a3a" stop-opacity="1"/>
                }
              </linearGradient>

              <!-- Filtro de brillo para el estado desbloqueado -->
              @if (badge.unlocked) {
                <filter [id]="'glow-' + badge.id" x="-30%" y="-30%" width="160%" height="160%">
                  <feGaussianBlur stdDeviation="3" result="blur"/>
                  <feMerge>
                    <feMergeNode in="blur"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
              }
            </defs>

            <!-- Hexágono exterior — borde gradiente -->
            <polygon
              points="40,4 72,22 72,58 40,76 8,58 8,22"
              fill="none"
              [attr.stroke]="'url(#' + gradId(badge.id) + ')'"
              stroke-width="2.5"
              stroke-linejoin="round"
              [attr.filter]="badge.unlocked ? 'url(#glow-' + badge.id + ')' : null" />

            <!-- Hexágono interior — relleno translúcido -->
            <polygon
              points="40,10 67,25 67,55 40,70 13,55 13,25"
              [attr.fill]="badge.unlocked ? badge.color + '18' : '#ffffff06'"
              stroke="none" />

            <!-- Puntos decorativos en las esquinas del hexágono -->
            @if (badge.unlocked) {
              <circle cx="40"  cy="4"  r="2.5" [attr.fill]="badge.color" opacity="0.9"/>
              <circle cx="72"  cy="22" r="2.5" [attr.fill]="badge.color" opacity="0.9"/>
              <circle cx="72"  cy="58" r="2.5" [attr.fill]="badge.color" opacity="0.9"/>
              <circle cx="40"  cy="76" r="2.5" [attr.fill]="badge.color" opacity="0.9"/>
              <circle cx="8"   cy="58" r="2.5" [attr.fill]="badge.color" opacity="0.9"/>
              <circle cx="8"   cy="22" r="2.5" [attr.fill]="badge.color" opacity="0.9"/>
            } @else {
              <circle cx="40"  cy="4"  r="2" fill="#4a4a5a" opacity="0.6"/>
              <circle cx="72"  cy="22" r="2" fill="#4a4a5a" opacity="0.6"/>
              <circle cx="72"  cy="58" r="2" fill="#4a4a5a" opacity="0.6"/>
              <circle cx="40"  cy="76" r="2" fill="#4a4a5a" opacity="0.6"/>
              <circle cx="8"   cy="58" r="2" fill="#4a4a5a" opacity="0.6"/>
              <circle cx="8"   cy="22" r="2" fill="#4a4a5a" opacity="0.6"/>
            }

            <!-- Líneas internas decorativas (destellos) solo si desbloqueado -->
            @if (badge.unlocked) {
              <line x1="40" y1="10" x2="40" y2="15" [attr.stroke]="badge.color" stroke-width="1" stroke-linecap="round" opacity="0.5"/>
              <line x1="40" y1="65" x2="40" y2="70" [attr.stroke]="badge.color" stroke-width="1" stroke-linecap="round" opacity="0.5"/>
              <line x1="16" y1="27" x2="20" y2="29" [attr.stroke]="badge.color" stroke-width="1" stroke-linecap="round" opacity="0.5"/>
              <line x1="60" y1="27" x2="64" y2="29" [attr.stroke]="badge.color" stroke-width="1" stroke-linecap="round" opacity="0.5"/>
            }
          </svg>

          <!-- Ícono central -->
          <div class="ach-badge__icon-wrap">
            <i class="pi {{ badge.icon }} ach-badge__icon"
               [style.color]="badge.unlocked ? badge.color : '#4a4a5a'">
            </i>
          </div>

          <!-- Candado si bloqueado -->
          @if (!badge.unlocked) {
            <div class="ach-badge__lock">
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="7" width="10" height="8" rx="2" fill="#3a3a4a" stroke="#5a5a6a" stroke-width="1"/>
                <path d="M5 7V5a3 3 0 0 1 6 0v2" stroke="#5a5a6a" stroke-width="1.5" stroke-linecap="round" fill="none"/>
                <circle cx="8" cy="11" r="1.5" fill="#5a5a6a"/>
              </svg>
            </div>
          }
        </div>

        <!-- Etiqueta del badge -->
        <p class="ach-badge__label">{{ badge.label }}</p>

        <!-- Descripción / tooltip -->
        @if (activeBadgeId === badge.id) {
          <div class="ach-badge__tooltip">
            <strong>{{ badge.label }}</strong>
            <span>{{ badge.description }}</span>
            @if (badge.unlocked && badge.unlockedAt) {
              <em>✓ {{ badge.unlockedAt }}</em>
            }
          </div>
        }

      </div>

    }
  </div>

</div>
}
